import initialState from './initialState';
import {SET_CART} from '../actions/CartActions';

export default function CartReducer(state = initialState.cart, action) {
    switch (action.type) {
        case SET_CART:
            const {data} = action.payload;
            return {...data};
        default:
            return state;
    }
}
